import React from 'react';
import { Booking } from '../../types';
import DateAndTimeIcon from '../icons/DateAndTimeIcon';
import { BookingDataView, BookingDataViewType } from './BookingDataView';
import { bookingStrings, str } from './strings';

const pendingStrings = bookingStrings.confirmation.pending;
const confirmationStrings = bookingStrings.confirmation.success;

interface BookingConfirmationPendingProps {
    confirmationData: Booking;
    closeConfirmation: () => void;
    rescheduleBooking: () => void;
    cancelBooking: () => void;
}

const BookingConfirmationPending = ({
    confirmationData,
    closeConfirmation,
    rescheduleBooking,
    cancelBooking,
}: BookingConfirmationPendingProps) => (
    <BookingDataView
        bookingData={confirmationData}
        dataAuto='booking-confirmation-pending-screen'
        onClose={closeConfirmation}
        type={BookingDataViewType.PENDING}
        title={str(pendingStrings.title)}
        subtitle={str(pendingStrings.subtitle)}
        svgIcon={<DateAndTimeIcon />}
    >
        <label>{str(confirmationStrings.change)}</label>
        <span onClick={rescheduleBooking}>
            {str(confirmationStrings.reschedule)}
        </span>
        <label>{str(confirmationStrings.or)}</label>
        <span onClick={cancelBooking}>{str(confirmationStrings.cancel)}</span>
    </BookingDataView>
);

export default BookingConfirmationPending;
